import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  getAllSubCategories,
  updateSubCategoriesById,
} from "../actions/subCategories";

const AdminSubCateEditModal = ({
  openEditSubCategoryModal,
  showEditSubCategoryModal,
  current,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const categories = useSelector((state) => state.categories);
  const subCategories = useSelector((state) => state.subCategories);
  const [values, setValues] = useState({
    name: "",
    categoryId: "",
    status: "",
  });
  console.log(values, "values");
  const handleChange = (fieldName) => (event) => {
    setValues({
      ...values,
      [fieldName]: event.target.value,
    });
  };

  const currentSubCate = async () => {
    try {
      setValues({
        id: "",
        categoryId: "",
        name: "",
        status: "",
      });
      setValues({
        id: current.id,
        categoryId: current.categoryId,
        name: current.name,
        status: current.status,
      });
    } catch (error) {
      // console.log(error);
    }
  };
  useEffect(() => {
    currentSubCate();
  }, [current]);

  const subCategoriesData = {
    _id: values.id,
    name: values.name,
    categoryId: values.categoryId,
    status: values.status,
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    for (let key of Object.keys(subCategoriesData)) {
      if (subCategoriesData[key] === "") {
        delete subCategoriesData[key];
      }
    }
    dispatch(updateSubCategoriesById(subCategoriesData));
    setTimeout(() => {
      // if (userData.isDriver === true) {
      dispatch(getAllSubCategories());
      // }
    }, 1000);
    openEditSubCategoryModal();
  };
  return (
    <>
      <div
        className={`modal fade ${
          showEditSubCategoryModal === true ? "show" : "hide"
        }`}
        id="addnewModal"
        tabIndex="-1"
        aria-labelledby="addnewModalLabel"
        // aria-hidden="true"
        onClick={(e) => {
          // Check if the click occurred outside the modal content
          if (e.target === e.currentTarget) {
            openEditSubCategoryModal(); // Call your close modal function
          }
        }}
      >
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="addnewModalLabel">
                Edit
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => openEditSubCategoryModal()}
              ></button>
            </div>
            <div className="modal-body">
              <form onSubmit={handleSubmit}>
                <fieldset>
                  <div className="row">
                    <div className="col-md-12">
                      <div className="text-center mb-3">
                        <label
                          className="avatar avatar-xxl profile-cover-avatar m-0 m-auto"
                          // htmlFor="avatar_upload"
                        >
                          <img
                            className="rounded border shadow-sm"
                            // src={defaultPic}
                            alt="picture"
                          />
                          <input
                            type="file"
                            id="avatar_upload"
                            className="d-none"
                            accept=".jpg, .jpeg, .png, .bmp"
                          />
                          <span className="avatar-edit">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              className="feather feather-edit-2 avatar-uploader-icon shadow-soft"
                            >
                              <path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"></path>
                            </svg>
                          </span>
                        </label>
                        <p
                          className="fw-light text-info"
                          style={{ fontSize: "12px" }}
                        >
                          .jpg, .jpeg, .png, .bmp recommended size (512 X 512)
                          pixels
                        </p>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label htmlFor="fName">Category Name</label>
                        {/* <input
                          type="text"
                          className="form-control"
                          id="fName"
                          placeholder="Category Name"
                        /> */}
                        <select
                          className="form-select"
                          id="CategoryName"
                          name="CategoryName"
                          value={values.categoryId} // Bind the selected value
                          onChange={handleChange("categoryId")} // Handle selection changes
                        >
                          <option value="">Select Category</option>
                          {categories?.categories?.map((category) => (
                            <option key={category?.id} value={category?.id}>
                              {category?.name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label htmlFor="fName">Sub Category Name</label>
                        <input
                          type="text"
                          className="form-control"
                          id="fName"
                          placeholder="Sub Category Name"
                          value={values.name}
                          onChange={handleChange("name")}
                        />
                      </div>
                    </div>
                  </div>
                </fieldset>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    data-bs-dismiss="modal"
                    onClick={() => openEditSubCategoryModal()}
                  >
                    Close
                  </button>
                  <button type="submit" className="btn btn-primary">
                    Save changes
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default AdminSubCateEditModal;
